import React, { useEffect, useState, useRef, useMemo } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { setStageReview } from "../../redux/actions/leadSourceActions";
import { DownloadOutlined } from '@ant-design/icons';
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  TableContainer,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from "../../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    backgroundColor: "#1C375D",
    color: 'white',
    textAlign: "center",
    fontWeight:'bold',
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
  submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: '#FFF2EB',
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const StageReview = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const stageReviewDetails = useSelector((state) => state.leadSource.stageReview);
  const [store, setStore] = useState([]);
  const [commonExpCenter, setExpCenter] = useState([]);
  const [storeDateFilter, setPivotDatefilters] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [showDetailedModal, setShowDetailedModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const csvButtonRef = useRef(null);
  const [leftPipelineCsvData, setLeftPipelineCsvData] = useState([]);
  const leftPipelineCsvButtonRef = useRef(null);
  const [rightPipelineSeCsvData, setRightPipelineSeCsvData] = useState([]);
  const rightPipelineSeCsvButtonRef = useRef(null);
  const [rightPipelineAsmCsvData, setRightPipelineAsmCsvData] = useState([]);
  const rightPipelineAsmCsvButtonRef = useRef(null);
  const [popMonthData, setPopMonthData] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectLost, setSeletLost] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const FIFTH_BUTTON_DISABLE_UNTIL_KEY = 'fifthButton_disableUntil';
  const [isDisabled, setIsDisabled] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const [rightPipeline, setRightPipeline] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];

  useEffect(() => {
    expCenters();
    checkPivot('stageReview')
    setSelectedRole('ALL')
  }, []);

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "projectCode", label: "Project No." },
    { key: "leadNumber", label: "Lead No." },
    { key: "clientName", label: "Client Name" },
    { key: "expCtrName", label: "Exp. Ctr Name" },
    { key: "currentStage", label: "Current Stage" },
    { key: "department", label: "Department" },
    { key: "leadCreatedDate", label: "Lead Created Date" },
    { key: "salesExecutive", label: "Sales Executive" },
    { key: "asm", label: "ASM" },
    { key: "callConnectedDate", label: "Call Connected Date" },
     ...(rightPipeline
    ? [
        { key: "cxMoveTimeline", label: "Cx Move-in Timeline" },
        { key: "possessionStatus", label: "Possession Status" },
        { key: "registrationStatus", label: "Registration Status" },
        { key: "decisionMaker", label: "Decision Maker" },
        { key: "financialReadiness", label: "Financial Readiness" },
        { key: "budgetQuotation", label: "Budget Vs Quotation" },
        { key: "competitorInvolvement", label: "Competitors Involvement" },
        { key: "otherCompetitorValue", label: "Other Competitor" },
        { key: "expectedSalesWonDate", label: "Expected Sales Won Date" },
      ]
    : [])
  ];

  const csvDownloadHandler = async (data) => {
    setLoading(true);
    try {
      let csvArray = [];
      for (let i = 0; i < popMonthData.length; i++) {
        let obj = {
            serialNo: i + 1,
            projectCode: popMonthData[i]?.erpProjectNo || "N/A",
            leadNumber: popMonthData[i]?.lead_no || "N/A",
            clientName: popMonthData[i]?.customerName || "N/A", // Corrected the optional chaining
            expCtrName: popMonthData[i]?.experienceCenterName || "N/A",
            currentStage: popMonthData[i]?.currentStage || "NA",
            department: popMonthData[i]?.departmentName || "NA",
            leadCreatedDate: moment(popMonthData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
            salesExecutive: popMonthData[i]?.salesUserName || "NA",
            asm: popMonthData[i]?.assistantSalesManagerName || "NA",
            callConnectedDate: moment(popMonthData[i]?.callConnectedDate).format('DD-MM-YYYY') || "NA",
            cxMoveTimeline: popMonthData[i]?.hotDealData?.cxMoveTimeline || 'NA',
            possessionStatus: popMonthData[i]?.hotDealData?.possessionStatus || 'NA',
            registrationStatus: popMonthData[i]?.hotDealData?.registrationStatus || 'NA',
            decisionMaker: popMonthData[i]?.hotDealData?.decisionMaker || 'NA',
            financialReadiness: popMonthData[i]?.hotDealData?.financialReadiness || 'NA',
            budgetQuotation: popMonthData[i]?.hotDealData?.budgetQuotation|| 'NA',
            competitorInvolvement: popMonthData[i]?.hotDealData?.competitorInvolvement || 'NA',
            otherCompetitorValue: popMonthData[i]?.hotDealData?.otherCompetitorValue || 'NA',
            expectedSalesWonDate: popMonthData[i]?.hotDealData?.expectedSalesWonDate ? moment(popMonthData[i]?.hotDealData?.expectedSalesWonDate).format('DD-MM-YYYY') : 'NA'

          };
          
        csvArray.push(obj);
      }
      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    setLoading(true);
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const expCenterData = {};
  store?.forEach((el) => {
      if (!expCenterData[el?.experienceCenterName]) {
          expCenterData[el?.experienceCenterName] = [];
      }
      expCenterData[el?.experienceCenterName].push(el);
  });

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter((user) => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers);
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

const stageReviewData = async (addExpCenter, usersData, selectedSearchType, searchInput) => {
    let expCenterData = addExpCenter?.map((el) => el._id);
    let users = "";
    if ((usersData?.users && usersData?.users.length !== 0) ||(selectedUsers && selectedUsers.length !== 0)) {
      users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
    }
    let obj = {
    startDate: storeDateFilter.startDate,
    endDate: storeDateFilter.endDate,
      selectedExperienceCenter: expCenterData ? expCenterData : "",
      tokenPercentage: selectedValue !== "" ? selectedValue : "",
      users: users ? users : "",
    userExpCenter: userDetails.experienceCenterId,
      lost: selectLost !== "" ? selectLost : "",
    pivotValue: "stageReview",
      searchType: selectedSearchType ? selectedSearchType : "",
      search: searchInput ? searchInput.toUpperCase() : "",
    selectedRole: 'ALL'
  };
  props.setLoading(true);
  props.setSnackInfo("Data Loading please wait...", "info");

  try {
    if (!stageReviewDetails || obj.startDate) {
      const [response1, response2, response3] = await Promise.all([
        HttpService.getStageReviewDataBasedOnExpCenter(obj),
        HttpService.getStageReviewDataBasedOnExpCentertable2(obj),
        HttpService.getStageReviewDataBasedOnExpCentertable3(obj)
      ]);
      const combinedArray = [
        ...(Array.isArray(response1.data.data) ? response1.data.data : []),
        ...(Array.isArray(response2.data.data) ? response2.data.data : []),
        ...(Array.isArray(response3.data.data) ? response3.data.data : [])
      ];

      setStore(combinedArray);
      dispatch(setStageReview(combinedArray));
    } else if (stageReviewDetails) {
      setStore(stageReviewDetails);
    }
  } 
  catch (error) {
    const errorMessage = error?.response?.data?.message || error?.response?.data || "Something went wrong. Please try again.";
    props.setSnackInfo(errorMessage, "error");
  } finally {
    props.setLoading(false);
  }
};

  const checkPivot = async (value) => {
    props.setLoading(true);
     if (value === 'stageReview') {
        stageReviewData();
        setSelectedExperienceCenter([]);
        setSelectedUsers([]);
        setSelectedRole("ALL")
        setSearchInput("")
        setSelectedSearchType("")
    } 
    props.setLoading(false);
}

  const formatNumberToTwoDecimalPlaces = (value) => {
    return parseFloat(value).toFixed(2);
  };

  const storePivotDate = (e) => {
    const { name, value } = e.target;
    setPivotDatefilters({ ...storeDateFilter, [name]: value });
  };
  const handlePivotDateFilter = () => {
    stageReviewData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleSearchType = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  const handleSearch = async (value) => {
    stageReviewData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && selectedSearchType && searchInput) {
      handleSearch(searchInput.toUpperCase());
    }
  };

  const handleMultipleExpData = (e, newvalue) => {
    setSelectedExperienceCenter(newvalue);
    handleExpData(newvalue);
  };

  const handleExpData = async (newvalue) => {
    props.setLoading(true);
    await stageReviewData(
      newvalue,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
    props.setLoading(false);
  };

  const clearDateFilter = () => {
    setSearchInput("");
    setSelectedSearchType("");
    setPivotDatefilters({
      startDate: "",
      endDate: "",
    });
      dispatch(setStageReview(null))
    setShouldRefresh(true) // Trigger the useEffect
    // stageReviewData(selectedExperienceCenter, selectedUsers, "", "");
  };

  useEffect(() => {
    // Check if there's a stored disable time in localStorage
    const disableUntilTimestamp = localStorage.getItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY);
    
    if (disableUntilTimestamp) {
        const now = new Date().getTime();
        const disableUntil = parseInt(disableUntilTimestamp, 10);
        
        // If the disable time is in the future, calculate remaining time
        if (disableUntil > now) {
        const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
        setTimeLeft(remainingTimeInSeconds);
        setIsDisabled(true);
        } else {
        // If the time has passed, clear localStorage
        localStorage.removeItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY);
        setIsDisabled(false);
        setTimeLeft(0);
        }
    }
    
    // Set up timer to update remaining time
    let timer;
    if (isDisabled && timeLeft > 0) {
        timer = setInterval(() => {
        setTimeLeft(prevTime => {
            const newTime = prevTime - 1;
            if (newTime <= 0) {
            // When time is up, clear localStorage and enable button
            localStorage.removeItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY);
            setIsDisabled(false);
            return 0;
            }
            return newTime;
        });
        }, 1000);
    }
    
    return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    useEffect(() => {
        if (shouldRefresh && stageReviewDetails === null) {
          stageReviewData(selectedExperienceCenter, selectedUsers, "", "");
            setShouldRefresh(false)
        }
    }, [shouldRefresh])

    // Format time for display
    const formatTimeLeft = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
    // Calculate the timestamp 4 minutes from now
    const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
    
    // Store the timestamp in localStorage
    localStorage.setItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
    
    // Disable the button for 4 minutes
    setIsDisabled(true);
    setTimeLeft(10); // 4 minutes in seconds
    
    // Run the original functionality
    setIsSpinning(true);
    clearDateFilter();
    setTimeout(() => {
        setIsSpinning(false);
    }, 1000);
    };


  const dataBasedOnClick = async (data, text) => {
    props.setLoading(true);
    setShowDetailedModal(true);
    setPopMonthData(data);
    const array = ['totalLeadReceived', 'totalPreSalesCalls', 'totalSalesCalls', 'remSetNoActionLeadReceived', 'remSetNoActionPreSalesCalls', 'remSetNoActionSalesCalls', 'remNotSetTotalLead', 'remNotSetPreSalesCalls', 'remNotSetSalesCalls' ];
    if(!array.includes(text)){
      setRightPipeline(true);
    }
    props.setLoading(false);
  }
  
  const res = useMemo(() => {
    return Object.assign({}, ...(store?.filter(item => item?.userName === "Total") || []));
}, [store]);
  // Function to generate CSV data for Left Pipeline table
  const generateLeftPipelineCsv = () => {
    try {
      if (!res) {
        setLeftPipelineCsvData([]);
        return;
      }

      const csvRows = [
        {
          "Metric": "Total Leads",
          "Lead Received from marketing and not called till now": res?.totalLeadReceivedCount || 0,
          "Call attended, requirement not collected": res?.totalPreSalesCallsCount || 0,
          "Requirement collected, quotation not sent": res?.totalSalesCallsCount || 0,
        },
        {
          "Metric": "No. of Leads where Reminders are Set but no action taken",
          "Lead Received from marketing and not called till now": res?.remSetNoActionLeadReceivedCount || 0,
          "Call attended, requirement not collected": res?.remSetNoActionPreSalesCallsCount || 0,
          "Requirement collected, quotation not sent": res?.remSetNoActionSalesCallsCount || 0,
        },
        {
          "Metric": "No. of Leads where Reminders are not Set",
          "Lead Received from marketing and not called till now": res?.remNotSetTotalLeadCount || 0,
          "Call attended, requirement not collected": res?.remNotSetPreSalesCallsCount || 0,
          "Requirement collected, quotation not sent": res?.remNotSetSalesCallsCount || 0,
        },
      ];

      setLeftPipelineCsvData(csvRows);
    } catch (error) {
      console.error("Error generating left pipeline CSV:", error);
      props?.setSnackInfo("Error generating left pipeline CSV", "error");
    }
  };

  // Function to generate CSV data for Right Pipeline SE table
  const generateRightPipelineSeCsv = () => {
    try {
      if (!res) {
        setRightPipelineSeCsvData([]);
        return;
      }

      const csvRows = [
        {
          "Metric": "Total Leads",
          "Quotation Sent": res?.qtSentTotalLeadsCount || 0,
          "Site/Office visit": res?.siteVisitTotalLeadsCount || 0,
          "Negotiation": res?.negotiationTotalLeadsCount || 0,
        },
        {
          "Metric": "No. of Leads where Reminders are Set but no action taken by SE in last 2 days",
          "Quotation Sent": res?.rmdSetNoActionSeQtSentCount || 0,
          "Site/Office visit": res?.rmdSetNoActionSeSiteVisitCount || 0,
          "Negotiation": res?.rmdSetNoActionSeNegotiationCount || 0,
        },
        {
          "Metric": "No. of Leads where Reminders are not Set by SE in last 2 days",
          "Quotation Sent": res?.rmdNotSetSeQtSentCount || 0,
          "Site/Office visit": res?.rmdNotSetSeSiteVisitCount || 0,
          "Negotiation": res?.rmdNotSetSeNegotiationCount || 0,
        },
        {
          "Metric": "No. of leads where notes are updated by SE in last 2 days",
          "Quotation Sent": res?.updatedNotesSeQtSentCount || 0,
          "Site/Office visit": res?.updatedNotesSeSiteVisitCount || 0,
          "Negotiation": res?.updatedNotesSeNegotiationCount || 0,
        },
        {
          "Metric": "No. of leads where notes are not updated by SE in last 2 days",
          "Quotation Sent": res?.notesNotUpdatedSeQtSentCount || 0,
          "Site/Office visit": res?.notesNotUpdatedSeSiteVisitCount || 0,
          "Negotiation": res?.notesNotUpdatedSeNegotiationCount || 0,
        },
      ];

      setRightPipelineSeCsvData(csvRows);
    } catch (error) {
      console.error("Error generating right pipeline SE CSV:", error);
      props?.setSnackInfo("Error generating right pipeline SE CSV", "error");
    }
  };

  // Function to generate CSV data for Right Pipeline ASM table
  const generateRightPipelineAsmCsv = () => {
    try {
      if (!res) {
        setRightPipelineAsmCsvData([]);
        return;
      }

      const csvRows = [
        {
          "Metric": "Total Leads",
          "Quotation Sent": res?.qtSentAsmTotalLeadsCount || 0,
          "Site/Office visit": res?.siteVisitAsmTotalLeadsCount || 0,
          "Negotiation": res?.negotiationAsmTotalLeadsCount || 0,
        },
        {
          "Metric": "No. of Leads where Reminders are Set but no action taken by ASM in last 2 days",
          "Quotation Sent": res?.rmdSetNoActionAsmQtSentCount || 0,
          "Site/Office visit": res?.rmdSetNoActionAsmSiteVisitCount || 0,
          "Negotiation": res?.rmdSetNoActionAsmNegotiationCount || 0,
        },
        {
          "Metric": "No. of Leads where Reminders are not Set by ASM in last 2 days",
          "Quotation Sent": res?.rmdNotSetAsmQtSentCount || 0,
          "Site/Office visit": res?.rmdNotSetAsmSiteVisitCount || 0,
          "Negotiation": res?.rmdNotSetAsmNegotiationCount || 0,
        },
        {
          "Metric": "No. of leads where notes are updated by ASM in last 2 days",
          "Quotation Sent": res?.updatedNotesAsmQtSentCount || 0,
          "Site/Office visit": res?.updatedNotesAsmSiteVisitCount || 0,
          "Negotiation": res?.updatedNotesAsmNegotiationCount || 0,
        },
        {
          "Metric": "No. of leads where notes are not updated by ASM in last 2 days",
          "Quotation Sent": res?.notesNotUpdatedAsmQtSentCount || 0,
          "Site/Office visit": res?.notesNotUpdatedAsmSiteVisitCount || 0,
          "Negotiation": res?.notesNotUpdatedAsmNegotiationCount || 0,
        },
      ];

      setRightPipelineAsmCsvData(csvRows);
    } catch (error) {
      console.error("Error generating right pipeline ASM CSV:", error);
      props?.setSnackInfo("Error generating right pipeline ASM CSV", "error");
    }
  };

  // Generate CSV data when store changes
  useEffect(() => {
    if (res && Object.keys(res).length > 0) {
        generateLeftPipelineCsv();
        generateRightPipelineSeCsv();
        generateRightPipelineAsmCsv();
    }
}, [store]);

  return (
    <div className="App">
      {/* first table */}
      <div>
        <div>
          <Paper className={classes.paper}>
            <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              {userDetails.roles.find(role => role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesHead || role.name === ROLENAME.Admin || role.name === ROLENAME.CenterHead || role.name == ROLENAME.AGMSales  || role.name == ROLENAME.SalesManager ) && userDetails.experienceCenterId.length > 1 &&
                <Grid item xs={12} sm={3}>
                    <FormControl style={{ width: "100%", marginTop: "0.4rem" }}>
                    <Autocomplete
                        multiple
                        value={selectedExperienceCenter}
                        onChange={handleMultipleExpData}
                        options={commonExpCenter}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Exp-Center"
                            variant="outlined"
                        />
                        )}
                    />
                    </FormControl>
                </Grid>
              }
        {/* {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesUser) && */}
           <>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="startDate"
                  name="startDate"
                  label="Lead Created From Date"
                  type="date"
                  variant="outlined"
                  value={storeDateFilter.startDate}
                  onChange={storePivotDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="endDate"
                  name="endDate"
                  label="Lead Created End Date"
                  type="date"
                  variant="outlined"
                  value={storeDateFilter.endDate}
                  onChange={storePivotDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handlePivotDateFilter}
                    style={{
                      backgroundColor: "#F50057",
                      color: "#fff",
                      padding: "0.4rem 2rem",
                    }}
                    className={classes.submitButton}
                  >
                    Submit
                  </Button>
                  <Button
                    onClick={handleRefreshClick}
                    variant="contained"
                    disabled={isDisabled}
                    style={{ 
                      backgroundColor: isDisabled ? "#cccccc" : "#F47E46", 
                      color: "#FFF2EB",
                      padding: "0.4rem 2rem",
                    }}
                  >
                    {isDisabled 
                      ? `Wait (${formatTimeLeft()})` 
                      : "Fetch New Data"}
                  </Button>
                </div>
              </Grid>
            </>
         {/* } */}
            </Grid>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <TextField
                select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSearchType}
                label="Search Type"
                name="searchType"
                onChange={(e) => handleSearchType(e.target.value)}
                variant="outlined"
                style={{ width: "30%", marginRight: "2%" }}
                size="small"
              >
                {searchTypes &&
                  searchTypes?.map((el, index) => (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Search Input */}
              <TextField
                label="Enter the input"
                name="searched"
                size="small"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={handleKeyDown} // Listening for the "Enter" key press
                variant="outlined"
                style={{ width: "80%" }}
              />

              {/* Search Button */}
              <Button
                disabled={!selectedSearchType || !searchInput}
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                onClick={() => handleSearch(searchInput.toUpperCase())}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearDateFilter}
              >
                Clear Filter
              </Button>
            </div>
          </Paper>
        </div>
        <br />
        <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginTop: '30px' }}>
            <CSVLink
              data={leftPipelineCsvData}
              filename={`Left_Pipeline_Stages_Review_${moment().format('YYYY-MM-DD')}.csv`}
              ref={leftPipelineCsvButtonRef}
              style={{ textDecoration: 'none', display: 'none' }}
            />
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              style={{
                backgroundColor: "#355025",
                color: "#FFF2EB",
                padding: "0.4rem 2rem",
                border: "none"
              }}
              onClick={() => {
                generateLeftPipelineCsv();
                setTimeout(() => {
                  if (leftPipelineCsvButtonRef.current && leftPipelineCsvData.length > 0) {
                    leftPipelineCsvButtonRef.current.link.click();
                  }
                }, 200);
              }}
            >
              Download CSV
            </Button>
          </div>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "10px" }}
            >
              <Table style={{ minWidth: "600px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        fontWeight:'bold',
                      }}
                      rowSpan={2}
                    >
                      Left Pipeline Stages Review
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Lead Received from marketing and not called till now
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                     Call attended, requirement not collected
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Requirement collected, quotation not sent
                    </StyledTableCell>
                  </StyledTableRow>
                  {/* count value row */}
                  <StyledTableRow>
                    <StyledTableCell className={classes.bordercolors} style={{fontWeight:'bold' }} >Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{fontWeight:'bold' }} >Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{fontWeight:'bold' }}>Count</StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}>Total Leads</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.totalLeadReceivedData, "totalLeadReceived")}>{res?.totalLeadReceivedCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.totalPreSalesCallsData, "totalPreSalesCalls")}>{res?.totalPreSalesCallsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.totalSalesCallsData, "totalSalesCalls")}>{res?.totalSalesCallsCount}</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are Set but no action taken </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remSetNoActionLeadReceivedData, "remSetNoActionLeadReceived")}>{res?.remSetNoActionLeadReceivedCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remSetNoActionPreSalesCallsData, "remSetNoActionPreSalesCalls")}>{res?.remSetNoActionPreSalesCallsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remSetNoActionSalesCallsData, "remSetNoActionSalesCalls")}>{res?.remSetNoActionSalesCallsCount}</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are not Set </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remNotSetTotalLeadData, "remNotSetTotalLead")}>{res?.remNotSetTotalLeadCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remNotSetPreSalesCallsData, "remNotSetPreSalesCalls")}>{res?.remNotSetPreSalesCallsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remNotSetSalesCallsData, "remNotSetSalesCalls")}>{res?.remNotSetSalesCallsCount}</StyledTableCell>

                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        {/* } */}
        </div>
      </div>
      {/* second table */}
        <div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginTop: '30px' }}>
            <CSVLink
              data={rightPipelineSeCsvData}
              filename={`Right_Pipeline_Stages_Review_SE_${moment().format('YYYY-MM-DD')}.csv`}
              ref={rightPipelineSeCsvButtonRef}
              style={{ textDecoration: 'none', display: 'none' }}
            />
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              style={{
                backgroundColor: "#355025",
                color: "#FFF2EB",
                padding: "0.4rem 2rem",
                border: "none"
              }}
              onClick={() => {
                generateRightPipelineSeCsv();
                setTimeout(() => {
                  if (rightPipelineSeCsvButtonRef.current && rightPipelineSeCsvData.length > 0) {
                    rightPipelineSeCsvButtonRef.current.link.click();
                  }
                }, 200);
              }}
            >
              Download CSV
            </Button>
          </div>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "10px" }}
            >
              <Table style={{ minWidth: "600px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        fontWeight:'bold',
                      }}
                      rowSpan={2}
                    >
                      Right Pipeline Stages Review (SE)
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Quotation Sent
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Site/Office visit
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Negotiation
                    </StyledTableCell>
                  </StyledTableRow>
                  {/* count value row */}
                  <StyledTableRow>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>

                  </StyledTableRow>
                </TableHead>

                <TableHead
                  style={{ position: "sticky", top: 0, background: "white" }}
                >
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}>Total Leads</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.qtSentTotalLeadsData, "qtSentTotalLeads")}>{res?.qtSentTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.siteVisitTotalLeadsData, "siteVisitTotalLeads")}>{res?.siteVisitTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.negotiationTotalLeadsData, "negotiationTotalLeads")}>{res?.negotiationTotalLeadsCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are Set but no action taken	by SE in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionSeQtSentData, "rmdSetNoActionSeQtSent")}>{res?.rmdSetNoActionSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionSeSiteVisitData, "rmdSetNoActionSeSiteVisit")}>{res?.rmdSetNoActionSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionSeNegotiationData, "rmdSetNoActionSeNegotiation")}>{res?.rmdSetNoActionSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are not Set	by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetSeQtSentData, "rmdNotSetSeQtSent")}>{res?.rmdNotSetSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetSeSiteVisitData, "rmdNotSetSeSiteVisit")}>{res?.rmdNotSetSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetSeNegotiationData, "rmdNotSetSeNegotiation")}>{res?.rmdNotSetSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of leads where notes are updated by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesSeQtSentData, "updatedNotesSeQtSent")}>{res?.updatedNotesSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesSeSiteVisitData, "updatedNotesSeSiteVisit")}>{res?.updatedNotesSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesSeNegotiationData, "updatedNotesSeNegotiation")}>{res?.updatedNotesSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of leads where notes are not updated by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedSeQtSentData, "notesNotUpdatedSeQtSent")}>{res?.notesNotUpdatedSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedSeSiteVisitData, "notesNotUpdatedSeSiteVisit")}>{res?.notesNotUpdatedSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedSeNegotiationData, "notesNotUpdatedSeNegotiation")}>{res?.notesNotUpdatedSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are connected by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedSeQtSentData, "callsConnectedSeQtSent")}>{res?.callsConnectedSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedSeSiteVisitData, "callsConnectedSeSiteVisit")}>{res?.callsConnectedSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedSeNegotiationData, "callsConnectedSeNegotiation")}>{res?.callsConnectedSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are not connected by SE in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedSeQtSentData, "callsNotConnectedSeQtSent")}>{res?.callsNotConnectedSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedSeSiteVisitData, "callsNotConnectedSeSiteVisit")}>{res?.callsNotConnectedSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedSeNegotiationData, "callsNotConnectedSeNegotiation")}>{res?.callsNotConnectedSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        {/*  } */}
        </div>
      {/* third table */}
      {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.Admin || role.name === ROLENAME.CenterHead || role.name === ROLENAME.SalesHead) &&
        <div style={{ maxHeight: "500px", overflow: "auto" }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', marginTop: '30px' }}>
            <CSVLink
              data={rightPipelineAsmCsvData}
              filename={`Right_Pipeline_Stages_Review_ASM_${moment().format('YYYY-MM-DD')}.csv`}
              ref={rightPipelineAsmCsvButtonRef}
              style={{ textDecoration: 'none', display: 'none' }}
            />
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              style={{
                backgroundColor: "#355025",
                color: "#FFF2EB",
                padding: "0.4rem 2rem",
                border: "none"
              }}
              onClick={() => {
                generateRightPipelineAsmCsv();
                setTimeout(() => {
                  if (rightPipelineAsmCsvButtonRef.current && rightPipelineAsmCsvData.length > 0) {
                    rightPipelineAsmCsvButtonRef.current.link.click();
                  }
                }, 200);
              }}
            >
              Download CSV
            </Button>
          </div>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "30px" }}
            >
              <Table style={{ minWidth: "600px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        fontWeight:'bold',
                      }}
                      rowSpan={2}
                    >
                      Right Pipeline Stages Review (ASM)
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Quotation Sent
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Site/Office visit
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Negotiation
                    </StyledTableCell>
                  </StyledTableRow>
                  {/* count value row */}
                  <StyledTableRow>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}>Total Leads</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.qtSentAsmTotalLeadsData, "qtSentAsmTotalLeads")}>{res?.qtSentAsmTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.siteVisitAsmTotalLeadsData, "siteVisitAsmTotalLeads")}>{res?.siteVisitAsmTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.negotiationAsmTotalLeadsData, "negotiationAsmTotalLeads")}>{res?.negotiationAsmTotalLeadsCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}>No. of Leads where Reminders are Set but no action taken	by ASM in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionAsmQtSentData, "rmdSetNoActionAsmQtSent")}>{res?.rmdSetNoActionAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionAsmSiteVisitData, "rmdSetNoActionAsmSiteVisit")}>{res?.rmdSetNoActionAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionAsmNegotiationData, "rmdSetNoActionAsmNegotiation")}>{res?.rmdSetNoActionAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}>  No. of Leads where Reminders are not Set	by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetAsmQtSentData, "rmdNotSetAsmQtSent")}>{res?.rmdNotSetAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetAsmSiteVisitData, "rmdNotSetAsmSiteVisit")}>{res?.rmdNotSetAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetAsmNegotiationData, "rmdNotSetAsmNegotiation")}>{res?.rmdNotSetAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}> No. of leads where notes are updated by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesAsmQtSentData, "updatedNotesAsmQtSent")}>{res?.updatedNotesAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesAsmSiteVisitData, "updatedNotesAsmSiteVisit")}>{res?.updatedNotesAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesAsmNegotiationData, "updatedNotesAsmNegotiation")}>{res?.updatedNotesAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}> No. of leads where notes are not updated by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedAsmQtSentData, "notesNotUpdatedAsmQtSent")}>{res?.notesNotUpdatedAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedAsmSiteVisitData, "notesNotUpdatedAsmSiteVisit")}>{res?.notesNotUpdatedAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedAsmNegotiationData, "notesNotUpdatedAsmNegotiation")}>{res?.notesNotUpdatedAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are connected by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedAsmQtSentData, "callsConnectedAsmQtSent")}>{res?.callsConnectedAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedAsmSiteVisitData, "callsConnectedAsmSiteVisit")}>{res?.callsConnectedAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedAsmNegotiationData, "callsConnectedAsmNegotiation")}>{res?.callsConnectedAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are not connected by ASM in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedAsmQtSentData, "callsNotConnectedAsmQtSent")}>{res?.callsNotConnectedAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedAsmSiteVisitData, "callsNotConnectedAsmSiteVisit")}>{res?.callsNotConnectedAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedAsmNegotiationData, "callsNotConnectedAsmNegotiation")}>{res?.callsNotConnectedAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
        </div>
      }

      <Modal
        title="Stage Review"
        centered
        visible={showDetailedModal}
        onCancel={() => setShowDetailedModal(false)}
        width={1000}
        maskClosable={true}
        footer={null}
        zIndex={2000}
      >
        <div className={classes.csv}>
          <CSVLink
            headers={headers}
            filename={`stageReviewData.csv`}
            data={csvData}
            ref={csvButtonRef}
          />
          <Button
            onClick={() => csvDownloadHandler(popMonthData)}
            style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
            variant="contained"
            color="secondary"
          >
            Download CSV
          </Button>
        </div>
        {popMonthData && (
          <TableContainer component={Paper} className={classes.table}>
            <Table
              style={{ width: 450 }}
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Sl. No.</StyledTableCell>
                  <StyledTableCell>Project No.</StyledTableCell>
                  <StyledTableCell>Lead No.</StyledTableCell>
                  <StyledTableCell>Client Name</StyledTableCell>
                  <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                  <StyledTableCell>Current Stage</StyledTableCell>
                  <StyledTableCell>Department</StyledTableCell>
                  <StyledTableCell>Lead Created Date</StyledTableCell>
                  <StyledTableCell>Sales Executive</StyledTableCell>
                  <StyledTableCell>ASM</StyledTableCell>
                  <StyledTableCell>Call Connected Date</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {popMonthData &&
                  popMonthData.map((data, i) => {
                    return (
                      <>
                        <StyledTableRow key={i}>
                          <StyledTableCell>{i + 1}</StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.erpProjectNo ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.erpProjectNo}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.lead_no ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.customerName}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.experienceCenterName}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.currentStage}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.departmentName}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.createdAt).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesUserName ? data?.salesUserName : 'NA'}
                          </StyledTableCell>
                           <StyledTableCell component="th">
                             {data?.assistantSalesManagerName ? data?.assistantSalesManagerName: 'NA'}
                            </StyledTableCell>
                           <StyledTableCell component="th">
                             {data?.callConnectedDate ? moment(data?.callConnectedDate).format('DD-MM-YYYY') : 'NA'}
                            </StyledTableCell>
                        </StyledTableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(StageReview);